'use strict';

var grey$1 = require('../../../../_virtual/grey.js_commonjs-exports.js');

Object.defineProperty(grey$1.__exports, "__esModule", {
  value: true
});
grey$1.__exports.default = void 0;
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
var _default = grey;
grey$1.__exports.default = _default;
